//get TeamMember
export const GET_TEAM_MEMBER = "GET_TEAM_MEMBER";

//TeamMember Details
export const TEAM_MEMBER_DETAILS = "TEAM_MEMBER_DETAILS";
export const TEAM_MEMBER_ID = "TEAM_MEMBER_ID";

//dialog type
export const OPEN_DIALOG = "OPEN_DIALOG";
export const CLOSE_DIALOG = "CLOSE_DIALOG";

//insert
export const INSERT_TEAM_MEMBER = "INSERT_TEAM_MEMBER";

//update TeamMember
export const UPDATE_TEAM_MEMBER = "UPDATE_TEAM_MEMBER";

//delete TeamMember
export const DELETE_TEAM_MEMBER = "DELETE_TEAM_MEMBER";

//toast
export const OPEN_TEAM_MEMBER_TOAST = "OPEN_TEAM_MEMBER_TOAST";
export const CLOSE_TEAM_MEMBER_TOAST = "CLOSE_TEAM_MEMBER_TOAST";
